
<header class="header-contain" [ngClass]="{'bg-light': isScrolled}">
    <div class="header-wrap ">
      <div>
        <a class="header-logo" routerLink="/" title="الرئيسية">
          <img [src]="imglogoUrl" alt="Logo" />
        </a>
  
      </div>
      <div class="header-data w-100 justify-content-between ">
        <ul class="header-links-wrap mx-5">
          <li class="header-links-item">
            <a class="header-link" [ngClass]="{'text-black': isScrolled}" routerLink="/"> {{DataHome[0]?.flatData?.pageTitle}}</a>
          </li>
  
          <li class="header-links-item">
            <div class="asset-wrap">
              <a class="header-link asset-icon" [ngClass]="{'text-black': isScrolled}" routerLink="about/establishment">{{DataAbout[0]?.flatData?.pageTitle}} </a>
              <svg class="inverted-svg-icon" fill="white" width="10" height="6" viewBox="0 0 10 6"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.29769 0.805695C9.26839 0.736298 9.20046 0.691162 9.12502 0.691162L0.875017 0.691254C0.79967 0.691254 0.731646 0.736389 0.702257 0.805786C0.672961 0.875183 0.688067 0.955475 0.740618 1.00949L4.86562 5.25214C4.90087 5.28839 4.94939 5.3089 5.00002 5.3089C5.05065 5.3089 5.09917 5.28839 5.13442 5.25214L9.25942 1.0094C9.31197 0.955292 9.32698 0.875092 9.29769 0.805695Z"
                   />
              </svg>
            </div>                                            
            <ul class="column-list">
              <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="about/establishment" >{{DataAbout[0]?.flatData?.aboutTitle}}</a>
                </div>
              </li>
              <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="about/vision" >{{DataAbout[0]?.flatData?.missionVisionSectionTitle}} </a>
                </div>
              </li>
              <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="about/standards" >{{DataAbout[0]?.flatData?.goalsSectionTitle}} </a>
                </div>
              </li>
              <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="about/team-work" > {{DataAbout[0]?.flatData?.teamMembersSectionTitle}}</a>
                </div>
              </li>
              <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="about/annual-reports" >{{DataAbout[0]?.flatData?. annualReportSectionTitle}}  </a>
                </div>
              </li>
            </ul>
          </li>
          
          <li class="header-links-item">
             <div class="asset-wrap">
               <a class="header-link asset-icon" [ngClass]="{'text-black': isScrolled}" routerLink="versions/economiclacapsules">{{pupdata[0]?.flatData?.pageTitle}}</a>
               <svg class="inverted-svg-icon" fill="white" width="10" height="6" viewBox="0 0 10 6"
               xmlns="http://www.w3.org/2000/svg">
               <path
                 d="M9.29769 0.805695C9.26839 0.736298 9.20046 0.691162 9.12502 0.691162L0.875017 0.691254C0.79967 0.691254 0.731646 0.736389 0.702257 0.805786C0.672961 0.875183 0.688067 0.955475 0.740618 1.00949L4.86562 5.25214C4.90087 5.28839 4.94939 5.3089 5.00002 5.3089C5.05065 5.3089 5.09917 5.28839 5.13442 5.25214L9.25942 1.0094C9.31197 0.955292 9.32698 0.875092 9.29769 0.805695Z"
                  />
             </svg>
             </div>
             <ul class="column-list">
               <li>
                 <div class="header-nested-links">
                   <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="versions/economiclacapsules"> {{pupdata[0]?.flatData?.economicCapsulesSectionTitle}}</a>
                 </div>
               </li>
         
               <li> 
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="versions/studies"> {{pupdata[0]?.flatData?.economicResearchesSectionTitle}}</a>
                </div>
              </li>
              <li> 
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="versions/economy-index"> {{pupdata[0]?.flatData?.economicIndicatorsSectionTitle}} </a>
                </div>
              </li>
              <li> 
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="versions/country-files"> {{pupdata[0]?.flatData?.economicCountryReportsSectionTitle}}</a>
                </div>
              </li>
             </ul>
           </li>
          
  
           <li class="header-links-item">
             <div class="asset-wrap">
               <a class="header-link asset-icon" [ngClass]="{'text-black': isScrolled}" routerLink="events/exhibitions">{{eventdata[0]?.flatData?.pageTitle}}</a>
               <svg class="inverted-svg-icon" fill="white" width="10" height="6" viewBox="0 0 10 6"
               xmlns="http://www.w3.org/2000/svg">
               <path
                 d="M9.29769 0.805695C9.26839 0.736298 9.20046 0.691162 9.12502 0.691162L0.875017 0.691254C0.79967 0.691254 0.731646 0.736389 0.702257 0.805786C0.672961 0.875183 0.688067 0.955475 0.740618 1.00949L4.86562 5.25214C4.90087 5.28839 4.94939 5.3089 5.00002 5.3089C5.05065 5.3089 5.09917 5.28839 5.13442 5.25214L9.25942 1.0094C9.31197 0.955292 9.32698 0.875092 9.29769 0.805695Z"
                  />
             </svg>
             </div>
             <ul class="column-list">
               <li>
                 <div class="header-nested-links">
                   <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="events/exhibitions">{{eventdata[0]?.flatData?.conferencesSectionTitle}} </a>
                 </div>
               </li>
               <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="events/seminars">  {{eventdata[0]?.flatData?.coursesSectionTitle}}</a>
                </div>
              </li>
              <li>
                <div class="header-nested-links">
                  <a class="header-nested-links-item" [ngClass]="{'text-black': isScrolled}" routerLink="events/lectures"> {{eventdata[0]?.flatData?.seminarsSectionTitle}} </a>
                </div>
              </li>
             </ul>
           </li>
           <li class="header-links-item">
            
            <a class="header-link" [ngClass]="{'text-black': isScrolled}"
            [queryParams]="{breadcrumbTitle: contactData?.flatData?.pageTitle }"
            routerLink="/contactUs">{{contactData?.flatData?.pageTitle}} </a>
          </li>
        </ul>
        <div class="header-login-lang-wrap">
          <div class="header-login">
            <ul class="header-links-wrap">
              <li class="header-links-item" *ngIf="false">
                <a class="header-link" >{{ 'sign-in'  }}</a>
              </li>
  
              <li class="header-links-item" *ngIf="false">
                <div class="asset-wrap">
                  <span class="header-link asset-icon"></span>
                  <svg class="inverted-svg-icon" width="10" height="6" viewBox="0 0 10 6"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M9.29769 0.805695C9.26839 0.736298 9.20046 0.691162 9.12502 0.691162L0.875017 0.691254C0.79967 0.691254 0.731646 0.736389 0.702257 0.805786C0.672961 0.875183 0.688067 0.955475 0.740618 1.00949L4.86562 5.25214C4.90087 5.28839 4.94939 5.3089 5.00002 5.3089C5.05065 5.3089 5.09917 5.28839 5.13442 5.25214L9.25942 1.0094C9.31197 0.955292 9.32698 0.875092 9.29769 0.805695Z"
                      />
                  </svg>
                </div>
                <ul class="user-dropdown">
                  <li>
                    <a class="asset-wrap" [ngClass]="{'text-black': isScrolled}" [routerLink]="['/ar/profile']">
                      <svg class="asset-icon" width="12" height="12" viewBox="0 0 12 12"  
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M10.7373 9.43984C10.4794 8.82895 10.1052 8.27405 9.63539 7.80605C9.16703 7.33671 8.61222 6.96251 8.0016 6.7041C7.99613 6.70137 7.99066 6.7 7.98519 6.69727C8.83695 6.08203 9.39066 5.07988 9.39066 3.94922C9.39066 2.07617 7.87308 0.558594 6.00003 0.558594C4.12699 0.558594 2.60941 2.07617 2.60941 3.94922C2.60941 5.07988 3.16312 6.08203 4.01488 6.69863C4.00941 6.70137 4.00394 6.70273 3.99847 6.70547C3.38597 6.96387 2.83636 7.33438 2.36468 7.80742C1.89534 8.27578 1.52113 8.83058 1.26273 9.44121C1.00887 10.039 0.871963 10.6799 0.859409 11.3293C0.859044 11.3439 0.861604 11.3584 0.866937 11.372C0.87227 11.3856 0.880268 11.398 0.890461 11.4084C0.900654 11.4189 0.912835 11.4272 0.926287 11.4328C0.939738 11.4385 0.954188 11.4414 0.968784 11.4414H1.7891C1.84925 11.4414 1.8971 11.3936 1.89847 11.3348C1.92582 10.2793 2.34964 9.29082 3.09886 8.5416C3.87406 7.76641 4.90355 7.33984 6.00003 7.33984C7.09652 7.33984 8.12601 7.76641 8.90121 8.5416C9.65042 9.29082 10.0743 10.2793 10.1016 11.3348C10.103 11.3949 10.1508 11.4414 10.211 11.4414H11.0313C11.0459 11.4414 11.0603 11.4385 11.0738 11.4328C11.0872 11.4272 11.0994 11.4189 11.1096 11.4084C11.1198 11.398 11.1278 11.3856 11.1331 11.372C11.1385 11.3584 11.141 11.3439 11.1407 11.3293C11.127 10.6758 10.9916 10.04 10.7373 9.43984ZM6.00003 6.30078C5.37249 6.30078 4.78187 6.05605 4.33753 5.61172C3.8932 5.16738 3.64847 4.57676 3.64847 3.94922C3.64847 3.32168 3.8932 2.73105 4.33753 2.28672C4.78187 1.84238 5.37249 1.59766 6.00003 1.59766C6.62757 1.59766 7.2182 1.84238 7.66253 2.28672C8.10687 2.73105 8.3516 3.32168 8.3516 3.94922C8.3516 4.57676 8.10687 5.16738 7.66253 5.61172C7.2182 6.05605 6.62757 6.30078 6.00003 6.30078Z"
                        />
                      </svg>
                      <span>حسابي</span>
                    </a>
                  </li>
  
                  <li>
                    <a class="asset-wrap" >
                      <svg class="asset-icon" width="12" height="12" viewBox="0 0 12 12" fill="none"
                        xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.75 7.31251C7.63397 7.31251 7.52269 7.3586 7.44064 7.44065C7.35859 7.52269 7.3125 7.63397 7.3125 7.75001V10.375C7.3124 10.491 7.26627 10.6022 7.18424 10.6842C7.10222 10.7663 6.991 10.8124 6.875 10.8125H1.625C1.50897 10.8125 1.39769 10.7664 1.31564 10.6844C1.23359 10.6023 1.1875 10.491 1.1875 10.375V1.625C1.1875 1.50897 1.23359 1.39769 1.31564 1.31565C1.39769 1.2336 1.50897 1.1875 1.625 1.1875H6.875C6.991 1.18761 7.10222 1.23374 7.18424 1.31576C7.26627 1.39779 7.3124 1.509 7.3125 1.625V4.25001C7.3125 4.36604 7.35859 4.47732 7.44064 4.55936C7.52269 4.64141 7.63397 4.68751 7.75 4.68751C7.86603 4.68751 7.97731 4.64141 8.05936 4.55936C8.14141 4.47732 8.1875 4.36604 8.1875 4.25001V1.625C8.18712 1.27703 8.04871 0.943408 7.80266 0.697349C7.5566 0.451291 7.22298 0.312887 6.875 0.312505H1.625C1.45258 0.312036 1.28177 0.345781 1.12248 0.411785C0.963191 0.477789 0.818579 0.57474 0.697019 0.697024C0.451674 0.943666 0.313505 1.27712 0.3125 1.625V10.375C0.313505 10.7229 0.451674 11.0563 0.697019 11.303C0.818579 11.4253 0.963191 11.5222 1.12248 11.5882C1.28177 11.6542 1.45258 11.688 1.625 11.6875H6.875C7.22298 11.6871 7.5566 11.5487 7.80266 11.3027C8.04871 11.0566 8.18712 10.723 8.1875 10.375V7.75001C8.1875 7.63397 8.14141 7.52269 8.05936 7.44065C7.97731 7.3586 7.86603 7.31251 7.75 7.31251Z"
                          fill="black" />
                        <path
                          d="M11.6538 6.16708C11.6868 6.0871 11.6953 5.99916 11.6785 5.91432C11.6616 5.82948 11.6201 5.75151 11.559 5.6902L9.80931 3.94068C9.7268 3.86099 9.61629 3.81689 9.50157 3.81789C9.38686 3.81888 9.27713 3.8649 9.19602 3.94601C9.1149 4.02713 9.06889 4.13686 9.06789 4.25157C9.0669 4.36628 9.11099 4.47679 9.19069 4.55931L10.1938 5.56249H3.375C3.25897 5.56249 3.14769 5.60859 3.06564 5.69064C2.98359 5.77268 2.9375 5.88396 2.9375 5.99999C2.9375 6.11603 2.98359 6.22731 3.06564 6.30935C3.14769 6.3914 3.25897 6.43749 3.375 6.43749H10.1938L9.19069 7.44068C9.1489 7.48104 9.11557 7.52932 9.09264 7.58269C9.06971 7.63607 9.05764 7.69348 9.05714 7.75157C9.05664 7.80966 9.0677 7.86727 9.0897 7.92104C9.1117 7.9748 9.14419 8.02365 9.18526 8.06473C9.22634 8.10581 9.27519 8.13829 9.32896 8.16029C9.38273 8.18229 9.44033 8.19336 9.49843 8.19285C9.55652 8.19235 9.61392 8.18028 9.6673 8.15735C9.72068 8.13442 9.76895 8.10109 9.80931 8.05931L11.559 6.30961C11.5997 6.26881 11.6319 6.22037 11.6538 6.16708Z"
                          fill="black" />
                      </svg>
                      <span>تسجيل الخروج</span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <div class="header-lang">
            <!-- <app-language-selector></app-language-selector> -->
          </div>
          <!-- <div class="search" style="margin: 0px 10px; "> 
              <input placeholder="ابحث">
  
              <svg width="18" height="19" viewBox="0 0 18 19"  xmlns="http://www.w3.org/2000/svg">
                <path d="M17.7263 17.0998L13.289 12.4701C14.4299 11.1095 15.055 9.39756 15.055 7.61539C15.055 3.45153 11.6781 0.0638428 7.52752 0.0638428C3.37691 0.0638428 0 3.45153 0 7.61539C0 11.7793 3.37691 15.1669 7.52752 15.1669C9.08571 15.1669 10.5706 14.6955 11.8401 13.8004L16.3111 18.4653C16.498 18.66 16.7494 18.7674 17.0187 18.7674C17.2737 18.7674 17.5156 18.6699 17.6992 18.4926C18.0893 18.116 18.1017 17.4915 17.7263 17.0998ZM7.52752 2.03381C10.5955 2.03381 13.0913 4.53764 13.0913 7.61539C13.0913 10.6931 10.5955 13.197 7.52752 13.197C4.45956 13.197 1.9637 10.6931 1.9637 7.61539C1.9637 4.53764 4.45956 2.03381 7.52752 2.03381Z" />
                </svg>
              
          </div> -->
        </div>
        
     

        <div class="megamenu-key-wrap justify-content-end w-100">
          <div class="megamenu-sign-in" *ngIf="false">
            <!-- <a (click)="onLoginClick()">{{ 'sign-in' | translate }}</a> -->
          </div>
          <div class="megamenu-sign-in  header-links-item" >
            <!-- <a class="asset-wrap" [ngClass]="{'text-black': isScrolled}" [routerLink]="['/ar/profile']">
              <svg class="asset-icon" width="16" height="16" viewBox="0 0 32 32" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M21.4579 17.2441C23.6625 15.5837 25.0907 12.9456 25.0907 9.97961C25.0907 4.96802 21.0133 0.890625 16.0013 0.890625C10.9897 0.890625 6.91235 4.96802 6.91235 9.97961C6.91235 12.9456 8.34021 15.5837 10.5448 17.2441C4.64221 19.4597 0.429688 25.1609 0.429688 31.8281H3.24219C3.24219 24.7925 8.96606 19.069 16.0017 19.069C23.037 19.069 28.7609 24.7925 28.7609 31.8281H31.5734C31.573 25.1609 27.3608 19.4597 21.4579 17.2441ZM9.72485 9.97961C9.72485 6.51855 12.5403 3.70312 16.0013 3.70312C19.4624 3.70312 22.2778 6.51855 22.2778 9.97961C22.2778 13.4407 19.4624 16.2565 16.0013 16.2565C12.5403 16.2565 9.72485 13.4407 9.72485 9.97961Z"
                  fill="white" />
              </svg>
              <span class="header-link">{{ username }}</span>
            </a> -->

            
          <div class="megamenu-key" (click)="handleMegamenu()" >
            <div class="megamenu-key-line"></div>
            <div class="megamenu-key-line"></div>
            <div class="megamenu-key-line"></div>
          </div>
          </div>
  
      
        </div>
      </div>
    </div>
  </header>


  <!--Mobile Menu-->
<div class="megamenu-contain" [class]="showMegaMenu ? 'open' : ''">
  <div class="megamenu-wrap">
    <div class="megamenu-head">
      <div class="megamenu-close" (click)="handleMegamenu()">
        <span aria-hidden="true">&times;</span>      </div>
      <!-- <app-language-selector></app-language-selector> -->
    </div>
    <div class="megamenu-body">
      <div class="megamenu-nav-wrap">
        <ul>
          <li class="megamenu-nav-item" (click)="handleMegamenu()">
            <a class="megamenu-nav-link" [routerLink]="['/']">{{ 'Home' }}</a>
          </li>
          <li class="megamenu-nav-item" (click)="handleMegamenu()">
            <a class="megamenu-nav-link" routerLink="about/establishment">{{ 'عن المركز' }}</a>
          </li>
          <li class="megamenu-nav-item" (click)="handleMegamenu()">
            <a class="megamenu-nav-link"  routerLink="versions/economiclacapsules">{{ 'الاصدارات' }}</a>
          </li>
          <li class="megamenu-nav-item" (click)="handleMegamenu()">
            <a class="megamenu-nav-link" routerLink="events/exhibitions">{{ 'الفاعليات' }}</a>
          </li>
          <li class="megamenu-nav-item"></li>
        </ul>
      </div>
    </div>
    <div class="megamenu-foot" *ngIf="false">
      <a class="asset-wrap logout-btn" >
        <svg class="asset-icon" width="12" height="12" viewBox="0 0 12 12" fill="none"
          xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7.75 7.31251C7.63397 7.31251 7.52269 7.3586 7.44064 7.44065C7.35859 7.52269 7.3125 7.63397 7.3125 7.75001V10.375C7.3124 10.491 7.26627 10.6022 7.18424 10.6842C7.10222 10.7663 6.991 10.8124 6.875 10.8125H1.625C1.50897 10.8125 1.39769 10.7664 1.31564 10.6844C1.23359 10.6023 1.1875 10.491 1.1875 10.375V1.625C1.1875 1.50897 1.23359 1.39769 1.31564 1.31565C1.39769 1.2336 1.50897 1.1875 1.625 1.1875H6.875C6.991 1.18761 7.10222 1.23374 7.18424 1.31576C7.26627 1.39779 7.3124 1.509 7.3125 1.625V4.25001C7.3125 4.36604 7.35859 4.47732 7.44064 4.55936C7.52269 4.64141 7.63397 4.68751 7.75 4.68751C7.86603 4.68751 7.97731 4.64141 8.05936 4.55936C8.14141 4.47732 8.1875 4.36604 8.1875 4.25001V1.625C8.18712 1.27703 8.04871 0.943408 7.80266 0.697349C7.5566 0.451291 7.22298 0.312887 6.875 0.312505H1.625C1.45258 0.312036 1.28177 0.345781 1.12248 0.411785C0.963191 0.477789 0.818579 0.57474 0.697019 0.697024C0.451674 0.943666 0.313505 1.27712 0.3125 1.625V10.375C0.313505 10.7229 0.451674 11.0563 0.697019 11.303C0.818579 11.4253 0.963191 11.5222 1.12248 11.5882C1.28177 11.6542 1.45258 11.688 1.625 11.6875H6.875C7.22298 11.6871 7.5566 11.5487 7.80266 11.3027C8.04871 11.0566 8.18712 10.723 8.1875 10.375V7.75001C8.1875 7.63397 8.14141 7.52269 8.05936 7.44065C7.97731 7.3586 7.86603 7.31251 7.75 7.31251Z"
            fill="black" />
          <path
            d="M11.6538 6.16708C11.6868 6.0871 11.6953 5.99916 11.6785 5.91432C11.6616 5.82948 11.6201 5.75151 11.559 5.6902L9.80931 3.94068C9.7268 3.86099 9.61629 3.81689 9.50157 3.81789C9.38686 3.81888 9.27713 3.8649 9.19602 3.94601C9.1149 4.02713 9.06889 4.13686 9.06789 4.25157C9.0669 4.36628 9.11099 4.47679 9.19069 4.55931L10.1938 5.56249H3.375C3.25897 5.56249 3.14769 5.60859 3.06564 5.69064C2.98359 5.77268 2.9375 5.88396 2.9375 5.99999C2.9375 6.11603 2.98359 6.22731 3.06564 6.30935C3.14769 6.3914 3.25897 6.43749 3.375 6.43749H10.1938L9.19069 7.44068C9.1489 7.48104 9.11557 7.52932 9.09264 7.58269C9.06971 7.63607 9.05764 7.69348 9.05714 7.75157C9.05664 7.80966 9.0677 7.86727 9.0897 7.92104C9.1117 7.9748 9.14419 8.02365 9.18526 8.06473C9.22634 8.10581 9.27519 8.13829 9.32896 8.16029C9.38273 8.18229 9.44033 8.19336 9.49843 8.19285C9.55652 8.19235 9.61392 8.18028 9.6673 8.15735C9.72068 8.13442 9.76895 8.10109 9.80931 8.05931L11.559 6.30961C11.5997 6.26881 11.6319 6.22037 11.6538 6.16708Z"
            fill="black" />
        </svg>
        <span>تسجيل الخروج</span>
      </a>
    </div>
  </div>
</div>
  
  